import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useUpdatePublicationQueries } from "@/queries/query-publication";

export const useDeletePublication = () => {
  const updatePublicationQuery = useUpdatePublicationQueries();

  return useMutationWithErrorHandler<
    void,
    ApiError,
    {
      publicationId: string;
    }
  >(async ({ publicationId }) => {
    await getRanaApiV1().PublicationsApi.publicationDelete({
      publicationId,
    });

    // Update the publications list
    updatePublicationQuery(publicationId, null);
  });
};
